// @flow
export default function makeRef(node: HTMLElement): null {
  if (node) {
    const refName = node.dataset.refName;
    if (!refName) {
      throw new Error('node passed to makeRef must have a data-ref-name attribute');
    }
    this[refName] = node;
  }

  return null;
}
